
import { defineComponent, reactive,ref, toRefs, computed} from 'vue'
import reportComfirmTitle from './title.vue'

interface State {
    brandName: string;
    modelName: string;
    vin: string;
    engineNo: string;
    logo: string;
    basicItemInfos: object[];
}
export default defineComponent({
    name: 'reportConfirmCarInfo',
    components: {
        reportComfirmTitle
    },
    props: {
        reportData: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    setup(props: any) {
        function setData (filedName) {
            return computed(() => {
                return props.reportData[filedName]
            })
        }
        let state: State = reactive({
            brandName: setData("brandName"),
            modelName: setData("modelName"),
            vin: setData("vin"),
            engineNo: setData("engineNo"),
            logo: setData("logo"),
            basicItemInfos: setData("basicItemInfos"),
        });
        function format (val){
            console.log(val);
        //    debugger;
            if (val.indexOf('-')>0) {
                let str = '';
                str = val.replace(/-/g, '.');
                return str;
            }
            return val;
        }
        return {
            state,
            format
        }
    }
})
